'use client';

import type { NolNotificationListItemType } from '@weberus/shared-types';
import type { HomeLogPageNameValue } from '@/app/(pages)/sub-home/[category]/constants';
import { NolNotificationBadgeType } from '@weberus/shared-types';
import { ProductBadge } from '@yanolja-rnd/nol-design-system';
import { clientLogStandardized } from '@weberus/client-tracker';

export interface NolNotificationListItemProps {
  widgetLogMeta?: object;
  pageNameLog: HomeLogPageNameValue;
  data?: NolNotificationListItemType;
}

const NolNotificationListItem = ({ widgetLogMeta, pageNameLog, data }: NolNotificationListItemProps) => {
  return (
    <li className="flex h-44 items-center border-b-[1px] border-b-line-neutral-weak2 pc:h-58">
      <a
        href={data?.action?.web}
        className="flex h-full w-full items-center"
        onClick={() =>
          clientLogStandardized('click', pageNameLog, {
            ...widgetLogMeta,
            objectType: 'noticeBannerId',
            ...data?.logMeta,
          })
        }>
        <ProductBadge
          className="flex-shrink-0"
          type={data?.badge?.type === NolNotificationBadgeType.NOTICE ? 'filled_secondary' : 'filled_basic'}>
          {data?.badge?.name}
        </ProductBadge>
        <div className="ml-8 truncate">
          <span className="typography-body-13-regular pc:typography-subtitle-16-regular">{data?.title}</span>
        </div>
      </a>
    </li>
  );
};

export default NolNotificationListItem;
